// extracted by mini-css-extract-plugin
export default {"refreshBackground":"BillsSummarySection_refreshBackground__LBEhn","pointerContainer":"BillsSummarySection_pointerContainer__pKCHc"};